module.exports = __webpack_public_path__ + "img/0013.5d1a578f.jpg";